import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { putDocumentUserRoles } from '../requests';
import type {
  PutDocumentsUserRolesRequestType,
  PutDocumentsUserRolesResponseType,
  UserRoleType,
} from '../types';

export const usePutDocumentUserRoles = (
  documentId?: PutDocumentsUserRolesRequestType['documentId'],
) => {
  const queryClient = useQueryClient();

  /**
   * Handles the success response of the mutation.
   *
   * @param data - The response data from the mutation.
   */
  const onSuccess = async (data: PutDocumentsUserRolesResponseType) => {
    queryClient.setQueryData(
      [API_QUERY_KEYS.documentsUserRoles, { documentId }],
      (oldData: UserRoleType[] = []) => [
        // remove direct users
        ...oldData.filter(user => !user.direct),
        // set new direct users
        ...data.data,
      ],
    );
  };

  return useMutation({
    mutationFn: (emails: string[]) =>
      putDocumentUserRoles({
        documentId: documentId!,
        emails,
      }),
    onSuccess,
  });
};
